"use strict";

angular.module('app.errSrcDirective', [])
    .directive('errSrc', function() {
      return {
        link: function(scope, element, attrs) {
          element.bind('error', function() {
            if (attrs.src != attrs.errSrc) {
              attrs.$set('src', attrs.errSrc);
            }
          });
        }
      }
    });


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/errSrcDirective.js